import React from "react";
import { api } from "../../lib/api";
import PageEditor from "./PageEditor";
import { Pencil, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

export default function PagesList() {
  const [pages, setPages] = React.useState([]);
  const [editing, setEditing] = React.useState(null);

  const load = () => api.adminPages().then(setPages);
  React.useEffect(() => { load(); }, []);

  if (editing) {
    return <PageEditor page={editing} onSaved={() => load()} onClose={() => { setEditing(null); load(); }} />;
  }

  return (
    <div data-testid="admin-pages-list">
      <div className="mb-8">
        <div className="brut-tag mb-3">CMS / SEITEN</div>
        <h1 className="brut-h2">Seiten verwalten</h1>
      </div>
      <table className="admin-table w-full">
        <thead>
          <tr className="border-b-2 border-[var(--ink)]">
            <th className="py-3 text-left">Slug</th>
            <th className="py-3 text-left">Titel</th>
            <th className="py-3 text-left">Nav</th>
            <th className="py-3 text-left">Sektionen</th>
            <th className="py-3 text-left">Status</th>
            <th className="py-3 text-right">Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {pages.map(p => (
            <tr key={p.id} className="border-b border-[var(--line-soft)]" data-testid={`page-row-${p.slug}`}>
              <td className="py-4 font-mono text-xs">/{p.slug}</td>
              <td className="py-4">{p.title_de}</td>
              <td className="py-4 font-mono text-xs uppercase">{p.nav_visible ? p.nav_label_de : "—"}</td>
              <td className="py-4 font-mono text-xs">{(p.sections || []).length}</td>
              <td className="py-4 font-mono text-xs uppercase">{p.published ? "veröffentlicht" : "entwurf"}</td>
              <td className="py-4 text-right space-x-2">
                <Link to={"/" + (p.slug === "home" ? "" : p.slug)} target="_blank" className="inline-flex items-center gap-1 font-mono text-xs underline"><ExternalLink size={12}/> Ansicht</Link>
                <button onClick={() => api.adminPage(p.id).then(setEditing)} className="brut-btn brut-btn-ghost !py-1.5 !px-3 text-xs" data-testid={`edit-page-${p.slug}`}><Pencil size={12}/> Bearbeiten</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
